
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { length, tryHead, empty as empty_1, contains, filter, singleton as singleton_1, ofArray, isEmpty, tryFind, choose, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { map as map_1, unwrap, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, stringHash, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import User_Multiple_Group from "../../../public/assets/icons/User_Multiple_Group.svg";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { Operators_IsNull } from "../../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import { Msg } from "./Types.js";
import Upload_File from "../../../public/assets/icons/Upload_File.svg";
import { Skeleton } from "../../Components/Skeleton.js";
import Delete_Circle from "../../../public/assets/icons/Delete_Circle.svg";
import { TextButton, Button, IconButton } from "../../Components/Button.js";
import Send_Email from "../../../public/assets/icons/Send_Email.svg";
import Check from "../../../public/assets/icons/Check.svg";
import { Input } from "../../Components/Input.js";
import User_Add_Plus from "../../../public/assets/icons/User_Add_Plus.svg";
import Padlock_Square_1 from "../../../public/assets/icons/Padlock_Square_1.svg";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { useEffectWithDeps } from "../../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { toString as toString_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { createDisposable } from "../../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { isUnread } from "./UnreadTracking.js";
import Help_Chat_2 from "../../../public/assets/icons/Help_Chat_2.svg";
import Cog from "../../../public/assets/icons/Cog.svg";

export function ConversationListItem(props) {
    let msg_1, msg_2, elems_3, elems_2, elems_1;
    const t = useTranslation()[0];
    let displayName;
    const matchValue = props.Conversation.Name;
    if (matchValue == null) {
        const _arg_1 = map((_arg) => _arg.Name, choose((userId) => tryFind((u) => (u.Id === userId), props.Users), props.Conversation.ParticipantUserIds));
        displayName = (isEmpty(_arg_1) ? t("chat.unknown_user") : join(", ", _arg_1));
    }
    else {
        displayName = matchValue;
    }
    let lastMessagePreview;
    const matchValue_1 = props.Conversation.LastMessage;
    lastMessagePreview = ((matchValue_1 == null) ? t("chat.no_messages") : (matchValue_1.IsDeleted ? ((msg_1 = matchValue_1, t("chat.message_deleted"))) : ((msg_2 = matchValue_1, defaultArg(msg_2.MessageText, t("chat.image_message"))))));
    let lastMessageTime;
    const matchValue_2 = props.Conversation.LastMessage;
    lastMessageTime = ((matchValue_2 == null) ? "" : toString(toLocalTime(matchValue_2.CreatedAt), "dd.MM. HH:mm"));
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("p-4"), delay(() => append(singleton("cursor-pointer"), delay(() => append(singleton("border-b"), delay(() => append(singleton("border-border"), delay(() => append(singleton("hover:bg-background"), delay(() => (props.IsSelected ? append(singleton("bg-background"), delay(() => append(singleton("border-l-4"), delay(() => singleton("border-l-primary"))))) : empty()))))))))))))))))))], ["onClick", (_arg_2) => {
        props.OnClick();
    }], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-center"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "truncate"])], (elems_1 = toList(delay(() => append(props.IsUnread ? singleton(reactElement("div", {
        className: join(" ", ["w-2.5", "h-2.5", "rounded-full", "bg-primary", "shrink-0"]),
    })) : empty(), delay(() => {
        let elems;
        return append(props.Conversation.IsGroup ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4", "shrink-0", "text-text-muted"])], (elems = [User_Multiple_Group()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => singleton(reactElement("span", {
            className: join(" ", toList(delay(() => append(singleton("text-sm"), delay(() => append(singleton("truncate"), delay(() => (props.IsUnread ? singleton("font-bold") : singleton("font-medium"))))))))),
            children: displayName,
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("span", {
        className: join(" ", ["text-xs", "text-text-muted", "whitespace-nowrap", "ml-2"]),
        children: lastMessageTime,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("span", {
        className: join(" ", toList(delay(() => append(singleton("text-xs"), delay(() => append(singleton("truncate"), delay(() => append(singleton("mt-1"), delay(() => (props.IsUnread ? append(singleton("text-black"), delay(() => singleton("font-semibold"))) : singleton("text-text-muted"))))))))))),
        children: lastMessagePreview,
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function MessageBubble(props) {
    let elems_3, elems_2;
    const patternInput = useTranslation();
    const timestampString = toString(toLocalTime(props.Message.CreatedAt), "dd.MM.yyyy, HH:mm");
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-end"), delay(() => (props.IsOwnMessage ? singleton("justify-end") : empty()))))))))], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("max-w-[60%]"), delay(() => append(singleton("mb-3"), delay(() => append(singleton("px-4"), delay(() => append(singleton("py-3"), delay(() => (props.IsOwnMessage ? append(singleton("bg-primary"), delay(() => singleton("text-white"))) : append(singleton("bg-white"), delay(() => append(singleton("border"), delay(() => singleton("border-border")))))))))))))))))))))))], (elems_2 = toList(delay(() => append(!props.IsOwnMessage ? singleton(reactElement("span", {
        className: join(" ", ["text-xs", "font-medium", "text-primary", "mb-1"]),
        children: props.SenderName,
    })) : empty(), delay(() => {
        let matchValue, text, elems_1;
        return append(props.Message.IsDeleted ? singleton(reactElement("span", {
            className: join(" ", toList(delay(() => append(singleton("text-sm"), delay(() => append(singleton("italic"), delay(() => (props.IsOwnMessage ? singleton("text-white/70") : singleton("text-text-muted"))))))))),
            children: patternInput[0]("chat.message_deleted"),
        })) : append((matchValue = props.Message.MessageText, (matchValue == null) ? (empty()) : ((text = matchValue, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-start", "justify-between", "gap-2"])], (elems_1 = toList(delay(() => append(singleton(reactElement("span", {
            className: join(" ", ["text-sm", "break-words", "flex-1"]),
            children: text,
        })), delay(() => {
            let elems;
            const matchValue_1 = props.OnDeleteClicked;
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                const onDelete = matchValue_1;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("h-3.5"), delay(() => append(singleton("w-3.5"), delay(() => append(singleton("shrink-0"), delay(() => append(singleton("cursor-pointer"), delay(() => append(singleton("opacity-60"), delay(() => append(singleton("hover:opacity-100"), delay(() => (props.IsOwnMessage ? singleton("text-white") : singleton("text-text-muted")))))))))))))))))], ["onClick", (e) => {
                    e.stopPropagation();
                    onDelete(props.Message.Id);
                }], (elems = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))))), delay(() => {
            const matchValue_2 = props.Message.ImageUrl;
            if (matchValue_2 == null) {
                return empty();
            }
            else {
                const imageUrl = matchValue_2;
                return singleton(reactElement("img", {
                    className: join(" ", ["mt-2", "rounded", "max-h-48", "object-cover"]),
                    src: imageUrl,
                }));
            }
        })), delay(() => singleton(reactElement("span", {
            className: join(" ", toList(delay(() => append(singleton("text-xs"), delay(() => append(singleton("mt-1"), delay(() => (props.IsOwnMessage ? singleton("text-white/70") : singleton("text-text-muted"))))))))),
            children: timestampString,
        }))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function ChatMessageArea(props) {
    let elems_14;
    const t = useTranslation()[0];
    const fileInputRef = reactApi.useRef(undefined);
    const dependencies = [props.Messages];
    reactApi.useEffect(() => {
        const element = document.getElementById(concat(props.IdPrefix, ..."chat-messages"));
        if (!Operators_IsNull(element)) {
            element.scrollTop = element.scrollHeight;
        }
    }, dependencies);
    const handleFiles = (files) => {
        if (files.length > 0) {
            const file = files[0];
            if (file.type.startsWith("image/")) {
                props.Dispatch(new Msg(50, [file]));
            }
        }
    };
    const isSending = props.FormState.IsLoading;
    const componentState = isSending ? "disabled" : "enabled";
    const canSend = ((props.NewMessage.trim() !== "") ? true : props.HasPendingImage) && !isSending;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "h-full", "min-h-0", "relative"])], ["onDragOver", (e) => {
        e.preventDefault();
        e.stopPropagation();
        props.Dispatch(new Msg(54, [true]));
    }], ["onDragLeave", (e_1) => {
        e_1.preventDefault();
        e_1.stopPropagation();
        props.Dispatch(new Msg(54, [false]));
    }], ["onDrop", (e_2) => {
        e_2.preventDefault();
        e_2.stopPropagation();
        props.Dispatch(new Msg(54, [false]));
        if (!isSending) {
            handleFiles(e_2.dataTransfer.files);
        }
    }], (elems_14 = toList(delay(() => {
        let elems_2, elems_1, elems;
        return append(props.IsDragOver ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["absolute", "inset-0", "z-10", "bg-primary/10", "border-2", "border-dashed", "border-primary", "rounded-lg", "flex", "items-center", "justify-center", "pointer-events-none"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "gap-2"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-10", "w-10", "text-primary"])], (elems = [Upload_File()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("span", {
            className: join(" ", ["text-primary", "font-medium", "text-sm"]),
            children: t("chat.drop_image_here"),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty(), delay(() => {
            let elems_4;
            return append(singleton(reactElement("div", createObj(ofArray([["id", concat(props.IdPrefix, ..."chat-messages")], ["className", join(" ", ["flex", "flex-col", "flex-1", "min-h-0", "overflow-y-auto", "p-4", "gap-1"])], (elems_4 = toList(delay(() => {
                let elems_3;
                const matchValue = props.Messages;
                return (matchValue.tag === 0) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "h-full"])], (elems_3 = [createElement(Skeleton, {
                    Variant: "normal",
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : (!isEmpty(matchValue.fields[0]) ? map((msg) => createElement(MessageBubble, {
                    IsOwnMessage: msg.SenderId === props.UserId,
                    Message: msg,
                    OnDeleteClicked: unwrap((msg.SenderId === props.UserId) ? ((msgId) => {
                        props.Dispatch(new Msg(45, [msgId]));
                    }) : undefined),
                    SenderName: msg.SenderUsername,
                }), matchValue.fields[0]) : singleton(reactElement("div", {
                    className: join(" ", ["flex", "items-center", "justify-center", "h-full", "text-text-muted"]),
                    children: t("chat.no_messages"),
                })));
            })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                let elems_13;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "border-border", "p-4", "shrink-0"])], (elems_13 = toList(delay(() => {
                    let matchValue_1, previewUrl, elems_8, elems_7, elems_6, elems_5;
                    return append((matchValue_1 = props.ImagePreviewUrl, (matchValue_1 == null) ? (empty()) : ((previewUrl = matchValue_1, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "mb-3"])], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", ["relative", "inline-block"])], (elems_7 = [reactElement("img", {
                        className: join(" ", ["h-20", "rounded", "object-cover", "border", "border-border"]),
                        src: previewUrl,
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["absolute", "-top-2", "-right-2", "h-5", "w-5", "bg-white", "rounded-full", "shadow", "cursor-pointer", "flex", "items-center", "justify-center", "text-text-muted", "hover:text-red-500"])], ["onClick", (e_3) => {
                        e_3.stopPropagation();
                        if (!isSending) {
                            props.Dispatch(new Msg(51, []));
                        }
                    }], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-3.5", "w-3.5"])], (elems_5 = [Delete_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))))))), delay(() => {
                        let elems_12, elems_9, elems_10, value_56, elems_11;
                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3", "items-center"])], (elems_12 = [reactElement("div", createObj(ofArray([["className", join(" ", ["shrink-0"])], (elems_9 = [reactElement("input", {
                            ref: (el) => {
                                if (!Operators_IsNull(el)) {
                                    fileInputRef.current = el;
                                }
                            },
                            type: "file",
                            accept: ".jpg,.jpeg,.png,.gif,.webp",
                            className: join(" ", ["hidden"]),
                            disabled: isSending,
                            onChange: (e_4) => {
                                const input = e_4.target;
                                if (!Operators_IsNull(input.files)) {
                                    handleFiles(input.files);
                                    input.value = "";
                                }
                            },
                        }), createElement(IconButton, {
                            ComponentState: componentState,
                            Icon: Upload_File(),
                            OnClick: () => {
                                const matchValue_2 = fileInputRef.current;
                                if (matchValue_2 == null) {
                                }
                                else {
                                    const el_1 = matchValue_2;
                                    el_1.click();
                                }
                            },
                            TestId: "chat-image-upload-button",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1"])], (elems_10 = [reactElement("textarea", createObj(ofArray([["id", concat(props.IdPrefix, ..."chat-input")], ["data-test-id", "chat-message-input"], ["autoFocus", true], ["className", join(" ", toList(delay(() => append(singleton("bg-white"), delay(() => append(singleton("border"), delay(() => append(singleton("focus:border-primary"), delay(() => append(singleton("focus:outline-none"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("w-full"), delay(() => append(singleton("px-3"), delay(() => append(singleton("py-2"), delay(() => append(singleton("text-base"), delay(() => append(singleton("font-normal"), delay(() => append(singleton("resize-none"), delay(() => append(singleton("max-h-24"), delay(() => (isSending ? append(singleton("text-text-muted"), delay(() => singleton("border-border-muted"))) : singleton("border-[#B6BECB]")))))))))))))))))))))))))))))], ["rows", 1], (value_56 = props.NewMessage, ["ref", (e_5) => {
                            if (!Operators_IsNull(e_5) && !equals(e_5.value, value_56)) {
                                e_5.value = value_56;
                            }
                        }]), ["onChange", (ev) => {
                            props.Dispatch(new Msg(5, [ev.target.value]));
                        }], ["disabled", isSending], ["onKeyDown", (e_6) => {
                            if ((e_6.key === "Enter") && !e_6.shiftKey) {
                                e_6.preventDefault();
                                props.Dispatch(new Msg(6, []));
                                const element_1 = document.getElementById(concat(props.IdPrefix, ..."chat-input"));
                                if (!Operators_IsNull(element_1)) {
                                    element_1.focus();
                                }
                            }
                        }], ["placeholder", t("chat.type_message")]])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), reactElement("div", createObj(singleton_1((elems_11 = [createElement(Button, {
                            ComponentState: canSend ? "enabled" : "disabled",
                            Icon: Send_Email(),
                            Label: "",
                            OnClick: () => {
                                props.Dispatch(new Msg(6, []));
                            },
                            TestId: "chat-send-button",
                            Variant: "primary",
                        })], ["children", reactApi.Children.toArray(Array.from(elems_11))]))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_13))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_14))])])));
}

export function UserSelectionList(props) {
    let elems_3;
    const filteredUsers = filter((u_2) => {
        if (props.SearchTerm === "") {
            return true;
        }
        else {
            return u_2.Name.toLocaleLowerCase().indexOf(props.SearchTerm.toLocaleLowerCase()) >= 0;
        }
    }, filter((u_1) => !contains(u_1.Id, props.ExcludeUserIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }), filter((u) => (u.Id !== props.CurrentUserId), props.Users)));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "overflow-y-auto", "px-4"])], (elems_3 = toList(delay(() => map((user) => {
        let elems_2;
        const isSelected = contains(user.Id, props.SelectedUserIds, {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: (x_1) => (stringHash(x_1) | 0),
        });
        return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("gap-3"), delay(() => append(singleton("p-3"), delay(() => append(singleton("cursor-pointer"), delay(() => append(singleton("rounded"), delay(() => append(singleton("hover:bg-background"), delay(() => (isSelected ? singleton("bg-background") : empty()))))))))))))))))))], ["data-test-id", concat("chat-user-", ...user.Id)], ["onClick", (_arg) => {
            props.Dispatch(new Msg(15, [user.Id]));
        }], (elems_2 = toList(delay(() => {
            let copyOfStruct;
            return append(singleton(reactElement("div", {
                className: join(" ", ["w-8", "h-8", "rounded-full", "bg-primary", "flex", "items-center", "justify-center", "text-white", "text-sm", "font-medium"]),
                children: (user.Name.length > 0) ? ((copyOfStruct = user.Name[0], copyOfStruct)).toLocaleUpperCase() : "?",
            })), delay(() => {
                let elems;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [reactElement("span", {
                    className: join(" ", ["text-sm", "font-medium"]),
                    children: user.Name,
                }), reactElement("span", {
                    className: join(" ", ["text-xs", "text-text-muted"]),
                    children: user.Department,
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                    let elems_1;
                    return isSelected ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["ml-auto", "h-5", "w-5", "text-primary"])], (elems_1 = [Check()], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    }, filteredUsers))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function NewChatDialog(props) {
    let elems_4, elems_3, elems, elems_1, elems_2;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["fixed", "inset-0", "z-50", "flex", "items-center", "justify-center", "bg-black/50"])], ["onClick", (e) => {
        e.stopPropagation();
        props.Dispatch(new Msg(10, []));
    }], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded-lg", "shadow-lg", "w-[500px]", "max-h-[600px]", "flex", "flex-col"])], ["onClick", (e_1) => {
        e_1.stopPropagation();
    }], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "border-b", "border-border", "flex", "justify-between", "items-center"])], (elems = [reactElement("span", {
        className: join(" ", ["font-medium", "text-lg"]),
        children: t("chat.new_chat"),
    }), createElement(IconButton, {
        ComponentState: "enabled",
        Icon: Delete_Circle(),
        OnClick: () => {
            props.Dispatch(new Msg(10, []));
        },
        TestId: "close-new-chat-dialog",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["p-4"])], (elems_1 = [createElement(Input, {
        ComponentState: "enabled",
        Label: t("chat.search_user"),
        OnChange: (arg) => {
            props.Dispatch(new Msg(14, [arg]));
        },
        TestId: "chat-search-user-input",
        Value: props.SearchTerm,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(UserSelectionList, {
        CurrentUserId: props.CurrentUserId,
        Dispatch: props.Dispatch,
        ExcludeUserIds: empty_1(),
        SearchTerm: props.SearchTerm,
        SelectedUserIds: props.SelectedUserIds,
        Users: props.Users,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "border-t", "border-border", "flex", "justify-end", "gap-3"])], (elems_2 = [createElement(TextButton, {
        ComponentState: "enabled",
        Label: t("general.cancel"),
        OnClick: () => {
            props.Dispatch(new Msg(10, []));
        },
        TestId: "cancel-new-chat",
        Variant: "muted",
    }), createElement(TextButton, {
        ComponentState: isEmpty(props.SelectedUserIds) ? "disabled" : "enabled",
        Label: t("chat.start_chat"),
        OnClick: () => {
            props.Dispatch(new Msg(16, []));
        },
        TestId: "start-new-chat",
        Variant: "blueButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function NewGroupDialog(props) {
    let elems_4, elems_3, elems, elems_1, elems_2, Label_3;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["fixed", "inset-0", "z-50", "flex", "items-center", "justify-center", "bg-black/50"])], ["onClick", (e) => {
        e.stopPropagation();
        props.Dispatch(new Msg(12, []));
    }], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded-lg", "shadow-lg", "w-[500px]", "max-h-[600px]", "flex", "flex-col"])], ["onClick", (e_1) => {
        e_1.stopPropagation();
    }], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "border-b", "border-border", "flex", "justify-between", "items-center"])], (elems = [reactElement("span", {
        className: join(" ", ["font-medium", "text-lg"]),
        children: t("chat.new_group"),
    }), createElement(IconButton, {
        ComponentState: "enabled",
        Icon: Delete_Circle(),
        OnClick: () => {
            props.Dispatch(new Msg(12, []));
        },
        TestId: "close-new-group-dialog",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "space-y-3"])], (elems_1 = [createElement(Input, {
        ComponentState: "enabled",
        Label: t("chat.group_name"),
        OnChange: (arg) => {
            props.Dispatch(new Msg(13, [arg]));
        },
        TestId: "chat-group-name-input",
        Value: props.GroupName,
    }), createElement(Input, {
        ComponentState: "enabled",
        Label: t("chat.search_user"),
        OnChange: (arg_1) => {
            props.Dispatch(new Msg(14, [arg_1]));
        },
        TestId: "chat-group-search-user-input",
        Value: props.SearchTerm,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(UserSelectionList, {
        CurrentUserId: props.CurrentUserId,
        Dispatch: props.Dispatch,
        ExcludeUserIds: empty_1(),
        SearchTerm: props.SearchTerm,
        SelectedUserIds: props.SelectedUserIds,
        Users: props.Users,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "border-t", "border-border", "flex", "justify-end", "gap-3"])], (elems_2 = [createElement(TextButton, {
        ComponentState: "enabled",
        Label: t("general.cancel"),
        OnClick: () => {
            props.Dispatch(new Msg(12, []));
        },
        TestId: "cancel-new-group",
        Variant: "muted",
    }), createElement(TextButton, (Label_3 = t("chat.create_group"), {
        ComponentState: (isEmpty(props.SelectedUserIds) ? true : (props.GroupName.trim() === "")) ? "disabled" : "enabled",
        Label: Label_3,
        OnClick: () => {
            props.Dispatch(new Msg(17, []));
        },
        TestId: "create-new-group",
        Variant: "blueButton",
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function GroupSettingsPanel(props) {
    let elems_15, elems, elems_14;
    const t = useTranslation()[0];
    const isLoading = props.FormState.IsLoading;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["w-80", "border-l", "border-border", "flex", "flex-col", "shrink-0", "min-h-0", "bg-white"])], (elems_15 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "border-b", "border-border", "flex", "justify-between", "items-center", "shrink-0"])], (elems = [reactElement("span", {
        className: join(" ", ["font-medium", "text-lg"]),
        children: t("chat.group_settings"),
    }), createElement(IconButton, {
        ComponentState: isLoading ? "disabled" : "enabled",
        Icon: Delete_Circle(),
        OnClick: () => {
            props.Dispatch(new Msg(25, []));
        },
        TestId: "close-group-settings",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "overflow-y-auto", "min-h-0"])], (elems_14 = toList(delay(() => {
        let elems_2, elems_1;
        return append(props.IsAdmin ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "border-b", "border-border"])], (elems_2 = [createElement(Input, {
            ComponentState: isLoading ? "disabled" : "enabled",
            Label: t("chat.group_name"),
            OnChange: (arg) => {
                props.Dispatch(new Msg(26, [arg]));
            },
            TestId: "edit-group-name-input",
            Value: defaultArg(props.EditingGroupName, ""),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-2", "flex", "justify-end"])], (elems_1 = [createElement(TextButton, {
            ComponentState: isLoading ? "disabled" : "enabled",
            Label: t("general.save"),
            OnClick: () => {
                props.Dispatch(new Msg(27, []));
            },
            TestId: "save-group-name",
            Variant: "blueButton",
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty(), delay(() => {
            let elems_12;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["p-4"])], (elems_12 = toList(delay(() => {
                let elems_3;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-center", "mb-3"])], (elems_3 = toList(delay(() => append(singleton(reactElement("span", {
                    className: join(" ", ["font-medium", "text-sm"]),
                    children: t("chat.members"),
                })), delay(() => (props.IsAdmin ? singleton(createElement(IconButton, {
                    ComponentState: isLoading ? "disabled" : "enabled",
                    Icon: User_Add_Plus(),
                    OnClick: () => {
                        props.Dispatch(new Msg(30, []));
                    },
                    TestId: "add-member-button",
                })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                    let elems_8, elems_6, elems_7;
                    return append((props.IsAddMemberOpen && props.IsAdmin) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4", "p-3", "border", "border-border", "rounded-lg"])], (elems_8 = [createElement(Input, {
                        ComponentState: "enabled",
                        Label: t("chat.search_user"),
                        OnChange: (arg_1) => {
                            props.Dispatch(new Msg(32, [arg_1]));
                        },
                        TestId: "add-member-search-input",
                        Value: props.AddMemberSearchTerm,
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["max-h-40", "overflow-y-auto", "mt-2"])], (elems_6 = toList(delay(() => map((user) => {
                        let elems_5;
                        const isSelected = contains(user.Id, props.SelectedUserIds, {
                            Equals: (x_1, y_1) => (x_1 === y_1),
                            GetHashCode: (x_1) => (stringHash(x_1) | 0),
                        });
                        return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("gap-2"), delay(() => append(singleton("p-2"), delay(() => append(singleton("cursor-pointer"), delay(() => append(singleton("rounded"), delay(() => append(singleton("hover:bg-background"), delay(() => (isSelected ? singleton("bg-background") : empty()))))))))))))))))))], ["onClick", (_arg_3) => {
                            props.Dispatch(new Msg(15, [user.Id]));
                        }], (elems_5 = toList(delay(() => append(singleton(reactElement("span", {
                            className: join(" ", ["text-sm"]),
                            children: user.Name,
                        })), delay(() => {
                            let elems_4;
                            return isSelected ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["ml-auto", "h-4", "w-4", "text-primary"])], (elems_4 = [Check()], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty();
                        })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
                    }, filter((u_2) => {
                        if (props.AddMemberSearchTerm === "") {
                            return true;
                        }
                        else {
                            return u_2.Name.toLocaleLowerCase().indexOf(props.AddMemberSearchTerm.toLocaleLowerCase()) >= 0;
                        }
                    }, filter((u_1) => !contains(u_1.Id, props.Conversation.ParticipantUserIds, {
                        Equals: (x, y) => (x === y),
                        GetHashCode: (x) => (stringHash(x) | 0),
                    }), filter((u) => (u.Id !== props.CurrentUserId), props.Users)))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-2", "flex", "justify-end", "gap-2"])], (elems_7 = [createElement(TextButton, {
                        ComponentState: isLoading ? "disabled" : "enabled",
                        Label: t("general.cancel"),
                        OnClick: () => {
                            props.Dispatch(new Msg(31, []));
                        },
                        TestId: "cancel-add-member",
                        Variant: "muted",
                    }), createElement(TextButton, {
                        ComponentState: (isLoading ? true : isEmpty(props.SelectedUserIds)) ? "disabled" : "enabled",
                        Label: t("chat.add_members"),
                        OnClick: () => {
                            props.Dispatch(new Msg(33, [props.SelectedUserIds]));
                        },
                        TestId: "confirm-add-members",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty(), delay(() => map((userId) => {
                        let elems_11;
                        const userName = defaultArg(map_1((_arg_6) => _arg_6.Name, tryFind((u_3) => (u_3.Id === userId), props.Users)), userId);
                        const isParticipantAdmin = contains(userId, props.Conversation.AdminUserIds, {
                            Equals: (x_2, y_2) => (x_2 === y_2),
                            GetHashCode: (x_2) => (stringHash(x_2) | 0),
                        });
                        const isCurrentUser = userId === props.CurrentUserId;
                        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-3", "py-2"])], (elems_11 = toList(delay(() => {
                            let copyOfStruct_1;
                            return append(singleton(reactElement("div", {
                                className: join(" ", toList(delay(() => append(singleton("w-8"), delay(() => append(singleton("h-8"), delay(() => append(singleton("rounded-full"), delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("text-white"), delay(() => append(singleton("text-sm"), delay(() => append(singleton("font-medium"), delay(() => (isParticipantAdmin ? singleton("bg-amber-500") : singleton("bg-primary"))))))))))))))))))))))),
                                children: (userName.length > 0) ? ((copyOfStruct_1 = userName[0], copyOfStruct_1)).toLocaleUpperCase() : "?",
                            })), delay(() => {
                                let elems_9;
                                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1", "min-w-0"])], (elems_9 = toList(delay(() => append(singleton(reactElement("span", {
                                    className: join(" ", ["text-sm", "font-medium", "truncate"]),
                                    children: userName,
                                })), delay(() => (isParticipantAdmin ? singleton(reactElement("span", {
                                    className: join(" ", ["text-xs", "text-amber-600"]),
                                    children: t("chat.admin"),
                                })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
                                    let elems_10;
                                    return (props.IsAdmin && !isCurrentUser) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-1"])], (elems_10 = toList(delay(() => append(!isParticipantAdmin ? singleton(createElement(IconButton, {
                                        ComponentState: isLoading ? "disabled" : "enabled",
                                        Icon: Padlock_Square_1(),
                                        OnClick: () => {
                                            props.Dispatch(new Msg(42, [userId, true]));
                                        },
                                        TestId: "set-admin-" + userId,
                                    })) : singleton(createElement(IconButton, {
                                        ComponentState: isLoading ? "disabled" : "enabled",
                                        Icon: Check_Circle(),
                                        OnClick: () => {
                                            props.Dispatch(new Msg(42, [userId, false]));
                                        },
                                        TestId: "remove-admin-" + userId,
                                    })), delay(() => singleton(createElement(IconButton, {
                                        ComponentState: isLoading ? "disabled" : "enabled",
                                        Icon: Delete_1(),
                                        OnClick: () => {
                                            props.Dispatch(new Msg(36, [userId]));
                                        },
                                        TestId: "remove-member-" + userId,
                                    })))))), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty();
                                }));
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_11))])])));
                    }, props.Conversation.ParticipantUserIds)));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                let elems_13, Label_5;
                return props.IsAdmin ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "border-t", "border-border"])], (elems_13 = [createElement(TextButton, (Label_5 = t("chat.delete_group"), {
                    ComponentState: isLoading ? "disabled" : "enabled",
                    Icon: Delete_1(),
                    Label: Label_5,
                    OnClick: () => {
                        props.Dispatch(new Msg(39, []));
                    },
                    TestId: "delete-group-button",
                    Variant: "redButton",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))) : empty();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_14))])])))], ["children", reactApi.Children.toArray(Array.from(elems_15))])])));
}

export function ChatOverviewView(props) {
    let elems_13;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.UserData, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffectWithDeps(() => {
        const hubUrl = concat(window.location.origin, "/hub/chat?userId=", ...props.UserData.UserId);
        const connection = (new HubConnectionBuilder()).withUrl(hubUrl).withAutomaticReconnect().build();
        connection.on("NewChatMessage", (rawConversationId) => {
            dispatch(new Msg(22, [parse(toString_1(rawConversationId))]));
        });
        let pr_1;
        const pr = connection.start();
        pr_1 = (pr.then(void 0, ((_arg_3) => {
        })));
        pr_1.then();
        return createDisposable(() => {
            let pr_3;
            const pr_2 = connection.stop();
            pr_3 = (pr_2.then(void 0, ((_arg_4) => {
            })));
            pr_3.then();
        });
    }, [props.UserData.UserId]);
    let users;
    const matchValue = state_1.Users;
    users = ((matchValue.tag === 0) ? empty_1() : matchValue.fields[0]);
    let conversations;
    const matchValue_1 = state_1.Conversations;
    conversations = ((matchValue_1.tag === 0) ? empty_1() : matchValue_1.fields[0]);
    let activeConversationId;
    const matchValue_2 = state_1.SelectedConversationId;
    activeConversationId = ((matchValue_2 == null) ? map_1((_arg_5) => _arg_5.Id, tryHead(conversations)) : matchValue_2);
    let activeConversation;
    if (activeConversationId == null) {
        activeConversation = undefined;
    }
    else {
        const id_1 = activeConversationId;
        activeConversation = tryFind((c_1) => (c_1.Id === id_1), conversations);
    }
    const isCurrentUserAdmin = (activeConversation == null) ? false : contains(props.UserData.UserId, activeConversation.AdminUserIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "h-full", "max-h-full", "overflow-hidden", "bg-white", "rounded-lg", "shadow-sm"])], (elems_13 = toList(delay(() => append(state_1.IsNewChatOpen ? singleton(createElement(NewChatDialog, {
        CurrentUserId: props.UserData.UserId,
        Dispatch: dispatch,
        SearchTerm: state_1.NewChatSearchTerm,
        SelectedUserIds: state_1.NewChatSelectedUserIds,
        Users: users,
    })) : empty(), delay(() => append(state_1.IsNewGroupOpen ? singleton(createElement(NewGroupDialog, {
        CurrentUserId: props.UserData.UserId,
        Dispatch: dispatch,
        GroupName: state_1.NewGroupName,
        SearchTerm: state_1.NewChatSearchTerm,
        SelectedUserIds: state_1.NewChatSelectedUserIds,
        Users: users,
    })) : empty(), delay(() => {
        let Title;
        return append(singleton(createElement(ConfirmationDialog, (Title = t("chat.delete_message"), {
            Description: t("chat.confirm_delete_message"),
            IsOpen: state_1.MessageToDelete != null,
            OnClose: () => {
                dispatch(new Msg(47, []));
            },
            OnConfirm: () => {
                dispatch(new Msg(46, []));
            },
            Title: Title,
        }))), delay(() => {
            let elems_7, elems_1, elems, elems_6;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["w-80", "border-r", "border-border", "flex", "flex-col", "shrink-0", "min-h-0"])], (elems_7 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "border-b", "border-border", "flex", "justify-between", "items-center", "shrink-0"])], (elems_1 = [reactElement("span", {
                className: join(" ", ["font-medium", "text-lg"]),
                children: t("chat.conversations"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-1"])], (elems = [createElement(IconButton, {
                ComponentState: "enabled",
                Icon: User_Multiple_Group(),
                OnClick: () => {
                    dispatch(new Msg(11, []));
                },
                TestId: "new-group-button",
            }), createElement(IconButton, {
                ComponentState: "enabled",
                Icon: User_Add_Plus(),
                OnClick: () => {
                    dispatch(new Msg(9, []));
                },
                TestId: "new-chat-button",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "overflow-y-auto", "min-h-0"])], (elems_6 = toList(delay(() => {
                let elems_5, elems_4, elems_2, elems_3;
                const matchValue_3 = state_1.Conversations;
                return (matchValue_3.tag === 0) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["p-4"])], (elems_5 = [createElement(Skeleton, {
                    Variant: "normal",
                })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : (!isEmpty(matchValue_3.fields[0]) ? map((convo_1) => createElement(ConversationListItem, {
                    Conversation: convo_1,
                    IsSelected: equals(activeConversationId, convo_1.Id),
                    IsUnread: isUnread(props.UserData.UserName, state_1.LastReadMap, convo_1),
                    OnClick: () => {
                        dispatch(new Msg(3, [convo_1.Id]));
                    },
                    Users: users,
                }), matchValue_3.fields[0]) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "justify-center", "h-full", "p-6", "text-center"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-12", "w-12", "text-text-muted", "mb-3"])], (elems_2 = [Help_Chat_2()], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("span", {
                    className: join(" ", ["text-sm", "text-text-muted"]),
                    children: t("chat.no_conversations"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "flex", "flex-col", "gap-2"])], (elems_3 = [createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("chat.new_chat"),
                    OnClick: () => {
                        dispatch(new Msg(9, []));
                    },
                    TestId: "new-chat-empty-button",
                    Variant: "blueButton",
                }), createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("chat.new_group"),
                    OnClick: () => {
                        dispatch(new Msg(11, []));
                    },
                    TestId: "new-group-empty-button",
                    Variant: "blueButton",
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                let elems_12;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "flex", "flex-col", "min-w-0", "min-h-0"])], (elems_12 = toList(delay(() => {
                    let elems_11, elems_10, elems_9;
                    if (activeConversationId == null) {
                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "justify-center", "h-full", "text-text-muted"])], (elems_11 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-16", "w-16", "mb-4"])], (elems_10 = [Help_Chat_2()], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), reactElement("span", {
                            className: join(" ", ["text-lg"]),
                            children: t("chat.select_conversation"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
                    }
                    else {
                        const conversationId = activeConversationId;
                        const matchValue_4 = tryFind((c_2) => (c_2.Id === conversationId), conversations);
                        if (matchValue_4 == null) {
                            return singleton(createElement(ChatMessageArea, {
                                Dispatch: dispatch,
                                FormState: state_1.FormState,
                                HasPendingImage: state_1.PendingImage != null,
                                IdPrefix: "",
                                ImagePreviewUrl: unwrap(state_1.ImagePreviewUrl),
                                IsDragOver: state_1.IsDragOver,
                                Messages: state_1.Messages,
                                NewMessage: state_1.NewMessage,
                                UserId: props.UserData.UserId,
                                UserName: props.UserData.UserName,
                            }));
                        }
                        else {
                            const convo_2 = matchValue_4;
                            let partnerName;
                            const matchValue_5 = convo_2.Name;
                            if (matchValue_5 == null) {
                                const _arg_14 = map((_arg_13) => _arg_13.Name, choose((userId) => tryFind((u_1) => (u_1.Id === userId), users), filter((id_2) => (id_2 !== props.UserData.UserId), convo_2.ParticipantUserIds)));
                                partnerName = (isEmpty(_arg_14) ? t("chat.unknown_user") : join(", ", _arg_14));
                            }
                            else {
                                partnerName = matchValue_5;
                            }
                            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "border-b", "border-border", "flex", "items-center", "gap-3", "shrink-0"])], (elems_9 = toList(delay(() => {
                                let copyOfStruct;
                                return append(singleton(reactElement("div", {
                                    className: join(" ", ["w-10", "h-10", "rounded-full", "bg-primary", "flex", "items-center", "justify-center", "text-white", "font-medium"]),
                                    children: (partnerName.length > 0) ? ((copyOfStruct = partnerName[0], copyOfStruct)).toLocaleUpperCase() : "?",
                                })), delay(() => {
                                    let elems_8;
                                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1", "min-w-0"])], (elems_8 = toList(delay(() => append(singleton(reactElement("span", {
                                        className: join(" ", ["font-medium", "truncate"]),
                                        children: partnerName,
                                    })), delay(() => {
                                        if (convo_2.IsGroup) {
                                            const membersLabel = t("chat.members");
                                            const count = length(convo_2.ParticipantUserIds) | 0;
                                            return singleton(reactElement("span", {
                                                className: join(" ", ["text-xs", "text-text-muted"]),
                                                children: (int32ToString(count) + " ") + membersLabel,
                                            }));
                                        }
                                        else {
                                            return empty();
                                        }
                                    })))), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => (convo_2.IsGroup ? singleton(createElement(IconButton, {
                                        ComponentState: "enabled",
                                        Icon: Cog(),
                                        OnClick: () => {
                                            if (state_1.IsGroupSettingsOpen) {
                                                dispatch(new Msg(25, []));
                                            }
                                            else {
                                                dispatch(new Msg(24, []));
                                            }
                                        },
                                        TestId: "group-settings-button",
                                    })) : empty())));
                                }));
                            })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => singleton(createElement(ChatMessageArea, {
                                Dispatch: dispatch,
                                FormState: state_1.FormState,
                                HasPendingImage: state_1.PendingImage != null,
                                IdPrefix: "",
                                ImagePreviewUrl: unwrap(state_1.ImagePreviewUrl),
                                IsDragOver: state_1.IsDragOver,
                                Messages: state_1.Messages,
                                NewMessage: state_1.NewMessage,
                                UserId: props.UserData.UserId,
                                UserName: props.UserData.UserName,
                            }))));
                        }
                    }
                })), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                    if (state_1.IsGroupSettingsOpen) {
                        const matchValue_6 = activeConversation;
                        let matchResult, convo_4;
                        if (matchValue_6 != null) {
                            if (matchValue_6.IsGroup) {
                                matchResult = 0;
                                convo_4 = matchValue_6;
                            }
                            else {
                                matchResult = 1;
                            }
                        }
                        else {
                            matchResult = 1;
                        }
                        switch (matchResult) {
                            case 0:
                                return singleton(createElement(GroupSettingsPanel, {
                                    AddMemberSearchTerm: state_1.AddMemberSearchTerm,
                                    Conversation: convo_4,
                                    CurrentUserId: props.UserData.UserId,
                                    Dispatch: dispatch,
                                    EditingGroupName: unwrap(state_1.EditingGroupName),
                                    FormState: state_1.FormState,
                                    IsAddMemberOpen: state_1.IsAddMemberOpen,
                                    IsAdmin: isCurrentUserAdmin,
                                    SelectedUserIds: state_1.NewChatSelectedUserIds,
                                    Users: users,
                                }));
                            default: {
                                return empty();
                            }
                        }
                    }
                    else {
                        return empty();
                    }
                }));
            }));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
}

